import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { BaseButtonLink } from 'bxcommon';

import { AdvisorHeader } from '../AdvisorHeader/AdvisorHeader';

import './DashboardView.scss';

export const DashboardView = () => {
  const navigate = useNavigate();
  const isAdmin = useSelector((state) => state.user.details.is_admin);

  useEffect(() => {
    if (!isAdmin) {
      navigate('/');
    }
  }, [isAdmin, navigate]);

  const { t } = useTranslation();

  return (
    <AdvisorHeader>
      <div className="dashboard-view">
        <h1>{t('dashboard.title')}</h1>
        <p>
          <BaseButtonLink onClick={() => navigate('/list')}>{t('dashboard.description.0')}</BaseButtonLink>
          {t('dashboard.description.1')}
        </p>
      </div>
    </AdvisorHeader>
  );
};

export default DashboardView;
